import React from "react";
import "./NotFound.css";

const NotFound = () => (
  <div className="NotFound" style={{ color: "White" }}>
    <h1>Sorry, page not found!</h1>
  </div>
);

export default NotFound;